import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheck = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20.5401 3.68986C21.4017 4.26427 21.6345 5.4284 21.0601 6.29002L12.0601 19.79C11.7485 20.2574 11.2438 20.5605 10.6848 20.6158C10.1258 20.6712 9.57138 20.473 9.17417 20.0758L3.17417 14.0758C2.44194 13.3435 2.44194 12.1564 3.17417 11.4241C3.90641 10.6919 5.09359 10.6919 5.82583 11.4241L10.2086 15.8069L17.9399 4.20989C18.5143 3.34828 19.6784 3.11545 20.5401 3.68986Z",
		fill: "currentColor"
	})]
});
export default SvgCheck;
